import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

import avatar1 from "../../assets/images/users/avatar-1.jpg";
import profileImg from "../../assets/images/logo.jpeg";

const WelcomeComp = () => {
  const [userData, setUserData] = useState({
    name: "Kullanıcı",
    tasksCount: 0,
    totalRevenue: 0,
    isLoading: true,
    roleTitle: "İş Ortağı"
  });

  useEffect(() => {
    const fetchUserStats = async () => {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const userId = authUser?.ID;
        const userName = authUser?.Users_NameSurname || "Kullanıcı";
        
        const userTypeId = Number(authUser?.Users_Type_ID);
        const isAdmin = userTypeId === 3;
        const isCustomer = userTypeId === 1;
        const isDriver = userTypeId === 2 || userTypeId === 4;

        if (!userId) {
          setUserData(prev => ({ ...prev, isLoading: false }));
          return;
        }

        let countValue = 0;
        let revenueValue = 0;

        if (isAdmin) {
          // Admin: tüm tamamlanan görevler + toplam ciro
          const [resTasks, resAdverts] = await Promise.all([
            fetch(`https://hiflowapi.stechomeyazilim.info/Advert_DeliveryStatus?$filter=Advert_DeliveryStatus_Status eq 'Tamamlandı'`),
            fetch(`https://hiflowapi.stechomeyazilim.info/Advert`),
          ]);
          const [dataTasks, dataAdverts] = await Promise.all([resTasks.json(), resAdverts.json()]);
          countValue = dataTasks.value?.length || 0;
          revenueValue = (dataAdverts.value || []).reduce((acc, curr) => acc + (curr.Price || 0), 0);
        } else if (isDriver) {
          // Sürücü: kabul edilen teklifleri + toplam kazanç
          const [resOffers, resAdverts] = await Promise.all([
            fetch(`https://hiflowapi.stechomeyazilim.info/Advert_Offers?$filter=Users_ID eq ${userId} and Offer_Status eq 'Kabul Edildi'`),
            fetch(`https://hiflowapi.stechomeyazilim.info/Advert?$filter=Users_ID eq ${userId}`),
          ]);
          const [dataOffers, dataAdverts] = await Promise.all([resOffers.json(), resAdverts.json()]);
          countValue = dataOffers.value?.length || 0;
          revenueValue = (dataAdverts.value || []).reduce((acc, curr) => acc + (curr.Price || 0), 0);
        } else {
          // Müşteri: aktif talepleri + toplam harcama
          const [resAdverts] = await Promise.all([
            fetch(`https://hiflowapi.stechomeyazilim.info/Advert?$filter=Users_ID eq ${userId}`),
          ]);
          const dataAdverts = await resAdverts.json();
          countValue = (dataAdverts.value || []).filter(a => a.Is_Active).length;
          revenueValue = (dataAdverts.value || []).reduce((acc, curr) => acc + (curr.Price || 0), 0);
        }

        const roleTitle = isAdmin ? "Sistem Yöneticisi" : isDriver ? "Taşıyıcı İş Ortağı" : "Müşteri";
        setUserData({
          name: userName,
          tasksCount: countValue,
          totalRevenue: revenueValue,
          isLoading: false,
          roleTitle,
          isAdmin,
          isDriver,
          isCustomer,
        });

      } catch (error) {
        console.error("Özet veriler çekilirken hata:", error);
        setUserData(prev => ({ ...prev, isLoading: false }));
      }
    };

    fetchUserStats();
  }, []);

  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const userTypeId = Number(authUser?.Users_Type_ID);
  const isAdmin = userTypeId === 3;
  const isDriver = userTypeId === 2 || userTypeId === 4;
  const isCustomer = userTypeId === 1;

  const countLabel = isAdmin ? "Toplam Görev" : isDriver ? "Kabul Edilen" : "Aktif Talebim";
  const revenueLabel = isAdmin ? "Toplam Ciro" : isDriver ? "Toplam Kazanç" : "Toplam Harcama";
  const headerSub = isAdmin ? "Yönetim Paneli Özeti" : isDriver ? "Sürücü Paneli" : "Müşteri Paneli";
  const linkTo = isAdmin ? "/contacts-list" : isCustomer ? "/ecommerce-add-product" : "/hesabim";
  const linkLabel = isAdmin ? "Kullanıcıları Yönet" : isCustomer ? "Yeni Talep Oluştur" : "Profili Görüntüle";

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary-subtle">
          <Row>
            <Col xs="7">
              <div className="text-primary p-3">
                <h5 className="text-primary">Tekrar Hoş Geldiniz !</h5>
                <p>{headerSub}</p>
              </div>
            </Col>
            <Col xs="5" className="align-self-end">
              <img src={profileImg} alt="" className="img-fluid" />
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row>
            <Col sm="4">
              <div className="avatar-md profile-user-wid mb-4">
                <img src={avatar1} alt="Profil" className="img-thumbnail" />
              </div>
              <h5 className="font-size-15 text-truncate">{userData.name}</h5>
              <p className="text-muted mb-0 text-truncate">{userData.roleTitle}</p>
            </Col>

            <Col sm="8">
              <div className="pt-4">
                <Row>
                  <Col xs="6">
                    <h5 className="font-size-15">
                      {userData.isLoading ? <Spinner size="sm" color="primary" /> : userData.tasksCount}
                    </h5>
                    <p className="text-muted mb-0">{countLabel}</p>
                  </Col>
                  <Col xs="6">
                    <h5 className="font-size-15">
                      {userData.isLoading ? <Spinner size="sm" color="primary" /> : `${userData.totalRevenue.toLocaleString("tr-TR")} TL`}
                    </h5>
                    <p className="text-muted mb-0">{revenueLabel}</p>
                  </Col>
                </Row>
                <div className="mt-4">
                  <Link to={linkTo} className="btn btn-primary btn-sm">
                    {linkLabel} <i className="mdi mdi-arrow-right ms-1"></i>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default WelcomeComp;